import React  from 'react';
import { Grid, TextField, Typography } from "@mui/material"
import { useRecoilState, useRecoilValue } from "recoil"
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom"
import { cleanRut, emailValidator, formatRut, removeCharactersSpecials, removeNumbers, validateEmail } from "src/shared/global/helpers"
import LandlineField from "./components/LandlineField"
import PhoneMobileField from "./components/PhoneMobileField"
import PrevisionAutocomplete from "./components/PrevisionAutocomplete"
import { errorsFormRegisterState, errorsReservationGuestState, valuesFormReservationGuestState } from "./state/atoms"
import { existPatientState } from 'src/SearchHours/state/atoms';

const FormReservationGuest = () => {
    const existPatient = useRecoilValue(existPatientState);
    const [errorsReservationGuest, setErrorsReservationGuest] = useRecoilState(errorsReservationGuestState);
    const [valuesFormReservationGuest, setValuesFormReservationGuest] = useRecoilState(valuesFormReservationGuestState)
    const { phoneEmpty } = useRecoilValue(errorsFormRegisterState);

    const handleChangeFormGuest = (ev) => {
        let { name, value } = ev.target;
        if (errorsReservationGuest.hasOwnProperty(name)) {
            setErrorsReservationGuest({ ...errorsReservationGuest, [name]: [] });
        }

        if (name === 'uprRut' && value !== '') {
            value = formatRut(cleanRut(value));
        }

        if (name === 'usuNombres' && value !== '') {
            value = removeNumbers(removeCharactersSpecials(value));
        }

        if (name === 'usuApePat' && value !== '') {
            value = removeNumbers(removeCharactersSpecials(value));
        }

        if (name === 'usuApeMat' && value !== '') {
            value = removeNumbers(removeCharactersSpecials(value));
        }

        // if (name === 'ageEmail' && value !== '') {
        //     value =   value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        // }
        if (name === 'ageEmail' && value !== '') {
            value = emailValidator(value);
        }
        if(name === 'ageEmailConfirm' && value !== ''){
            value = emailValidator(value);
        }

        if (value === undefined) value = ''

        setValuesFormReservationGuest({
            ...valuesFormReservationGuest,
            [name]: value
        })
    }

    return (
        <div className='animate__animated animate__fadeIn'>
            <Grid container spacing={2}>
                <Grid item md={6} xs={12} hidden={existPatient}>
                    <InputLabelCustom htmlFor="input-rut" text="RUT paciente (*)" />
                    <TextField
                        disabled={true}
                        size="small"
                        id="input-rut"
                        error={errorsReservationGuest['uprRut'] && errorsReservationGuest['uprRut'].length > 0 ? true : false}
                        helperText={errorsReservationGuest['uprRut'] && errorsReservationGuest['uprRut'].length > 0 ? `${errorsReservationGuest['uprRut'].join("\n")}` : ''}
                        style={{ width: '100%' }}
                        name="uprRut"
                        type="text"
                        value={valuesFormReservationGuest.uprRut || ""}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            maxLength: 12
                        }}
                        sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000", // Ajusta el color del texto
                                color: "#000000", // Compatibilidad adicional
                            },
                        }}
                        variant="outlined"
                        // onChange={handleChangeFormGuest}
                        autoComplete="off"
                        placeholder="Ej: 16.000.000-0"
                    />
                </Grid>

                <Grid item md={6} xs={12} hidden={existPatient}>
                    <InputLabelCustom htmlFor="input-nombres" text="Nombre(s) (*)" />
                    <TextField
                        id="input-nombres"
                        size="small"
                        error={errorsReservationGuest['usuNombres'] && errorsReservationGuest['usuNombres'].length > 0 ? true : false}
                        helperText={errorsReservationGuest['usuNombres'] && errorsReservationGuest['usuNombres'].length > 0 ? `${errorsReservationGuest['usuNombres'].join("\n")}` : ''}
                        style={{ width: '100%' }}
                        name="usuNombres"
                        type="text"
                        value={valuesFormReservationGuest.usuNombres || ""}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        onChange={handleChangeFormGuest}
                        autoComplete="off"
                        placeholder="Ej: José Pedro"
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2} mt={1}>
                <Grid item md={6} xs={12} hidden={existPatient}>
                    <InputLabelCustom htmlFor="input-apepat" text="Apellido paterno (*)" />
                    <TextField
                        id="input-apepat"
                        size="small"
                        error={errorsReservationGuest['usuApePat'] && errorsReservationGuest['usuApePat'].length > 0 ? true : false}
                        helperText={errorsReservationGuest['usuApePat'] && errorsReservationGuest['usuApePat'].length > 0 ? `${errorsReservationGuest['usuApePat'].join("\n")}` : ''}
                        style={{ width: '100%' }}
                        name="usuApePat"
                        type="text"
                        value={valuesFormReservationGuest.usuApePat || ""}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        onChange={handleChangeFormGuest}
                        autoComplete="off"
                        placeholder="Ej: Cifuentes"
                    />
                </Grid>

                <Grid item md={6} xs={12} hidden={existPatient}>
                    <InputLabelCustom htmlFor="input-apemat" text="Apellido materno (Opcional)" />
                    <TextField
                        id="input-apemat"
                        size="small"
                        error={errorsReservationGuest['usuApeMat'] && errorsReservationGuest['usuApeMat'].length > 0 ? true : false}
                        helperText={errorsReservationGuest['usuApeMat'] && errorsReservationGuest['usuApeMat'].length > 0 ? `${errorsReservationGuest['usuApeMat'].join("\n")}` : ''}
                        style={{ width: '100%' }}
                        name="usuApeMat"
                        type="text"
                        value={valuesFormReservationGuest.usuApeMat || ""}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        onChange={handleChangeFormGuest}
                        autoComplete="off"
                        placeholder="Ej: Rodriguez"
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2} mt={1}>
                <Grid item md={6} xs={12} hidden={existPatient}>
                    <InputLabelCustom htmlFor="input-fechanac" text="Fecha de nacimiento (*)" />
                    <TextField
                        id="input-fechanac"
                        size="small"
                        error={errorsReservationGuest['fechaNac'] && errorsReservationGuest['fechaNac'].length > 0 ? true : false}
                        helperText={errorsReservationGuest['fechaNac'] && errorsReservationGuest['fechaNac'].length > 0 ? `${errorsReservationGuest['fechaNac'].join("\n")}` : ''}
                        style={{ width: '100%' }}
                        name="fechaNac"
                        type="date"
                        value={valuesFormReservationGuest.fechaNac || ""}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            min: "1900-01-01",
                            max: new Date().toISOString().split("T")[0]
                        }}
                        variant="outlined"
                        onChange={handleChangeFormGuest}
                        autoComplete="off"
                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabelCustom htmlFor="autcomplete-prevision" text="Previsión" />
                    <PrevisionAutocomplete/>
                </Grid>
            </Grid>

            <Grid container spacing={2} mt={1}>
                <Grid item md={6} xs={12}>
                    <PhoneMobileField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <LandlineField />
                </Grid>
                {
                    phoneEmpty.length > 0 && (
                        <Grid item xs={12} md={12} display={"flex"} justifyContent={"center"}>
                            <Typography color="error" fontSize={"0.75rem"}>{phoneEmpty.join("\n")}</Typography>
                        </Grid>
                    )
                }
            </Grid>

            <Grid container spacing={2} mt={1}>
                <Grid item md={6} xs={12}>
                    <InputLabelCustom htmlFor="input-email" text="Correo electrónico" />
                    <TextField
                        id="input-email"
                        size="small"
                        error={errorsReservationGuest['ageEmail'] && errorsReservationGuest['ageEmail'].length > 0 ? true : false}
                        helperText={errorsReservationGuest['ageEmail'] && errorsReservationGuest['ageEmail'].length > 0 ? `${errorsReservationGuest['ageEmail'].join("\n")}` : ''}
                        style={{ width: '100%' }}
                        name="ageEmail"
                        type="text"
                        value={valuesFormReservationGuest.ageEmail || ""}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        onChange={handleChangeFormGuest}
                        autoComplete="off"
                        placeholder="Ej: correo@dominio.cl"
                    />
                </Grid>
                <Grid item md={6} xs={12}>
                    <InputLabelCustom htmlFor="input-email" text="Confirme Correo electrónico" />
                    <TextField
                        id="input-email"
                        size="small"
                        error={errorsReservationGuest['ageEmailConfirm'] && errorsReservationGuest['ageEmailConfirm'].length > 0 ? true : false}
                        helperText={errorsReservationGuest['ageEmailConfirm'] && errorsReservationGuest['ageEmailConfirm'].length > 0 ? `${errorsReservationGuest['ageEmailConfirm'].join("\n")}` : ''}
                        style={{ width: '100%' }}
                        name="ageEmailConfirm"
                        type="text"
                        value={valuesFormReservationGuest.ageEmailConfirm || ""}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        onChange={handleChangeFormGuest}
                        autoComplete="off"
                        placeholder="Ej: correo@dominio.cl"
                        onCopy={
                            (e) => 
                                e.preventDefault()
                        }
                        onPaste={
                            (e) => 
                                e.preventDefault()
                        }
                    />
                </Grid>
            </Grid>

        </div>
    )
}

export default FormReservationGuest;